import { useMemo, useState } from 'react'
import LeadTimeRecebimentoCargaHttp from '../../../../services/api/https/registration/lead-time-recebimento-carga.http'
import {
  getCentraisOperacoes,
  getEmpresas,
} from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

const empresas = getEmpresas()
const centraisOperacao = getCentraisOperacoes()

export const LEAD_ACTIONS = {
  FETCH_LEADS: 'FETCH_LEADS',
  SAVE_LEADS: 'SAVE_LEADS',
  NONE: 'NONE',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
}

const INITIAL_STATE = {
  centraisOperacao,
  empresas,
  leadTimes: [],
  selectedCentral: '',
  selectedEmpresa: '',
  loading: LEAD_ACTIONS.NONE,
  errorMessage: null,
  successMessage: null,
}

export default function useLeadTimeRecebimentoCargaState() {
  const [state, setState] = useState(INITIAL_STATE)

  const localDispatch = useMemo(() => {
    return {
      onLeadTimeChange(data) {
        setState(prevState => {
          const index = prevState.leadTimes.findIndex(l => l.tp_nome === data.tp_nome)
          if (index !== -1) {
            prevState.leadTimes[index] = data
          }
          return { ...prevState }
        })
      },
      async fetchLeadsTime(selectedCentral, selectedEmpresa) {
        try {
          setState(prevState => ({
            ...prevState,
            selectedCentral,
            selectedEmpresa,
            loading: LEAD_ACTIONS.FETCH_LEADS,
          }))
          if (selectedCentral === '' || selectedEmpresa === '') {
            setState(prevState => ({
              ...prevState,
              loading: LEAD_ACTIONS.NONE,
            }))
          } else {
            const leadTimes = await LeadTimeRecebimentoCargaHttp.getLeadTime(
              selectedCentral.id,
              selectedEmpresa.id,
            )
            setState(prevState => ({
              ...prevState,
              leadTimes,
              loading: LEAD_ACTIONS.NONE,
            }))
          }
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            loading: LEAD_ACTIONS.NONE,
            errorMessage: errorHandler(error),
          }))
        }
      },
      async onBtnSalvarClick(leads) {
        try {
          setState(prevState => ({ ...prevState, loading: LEAD_ACTIONS.SAVE_LEADS }))
          const leadTimes = await LeadTimeRecebimentoCargaHttp.salvarLeadTime(leads)
          setState(prevState => ({
            ...prevState,
            loading: LEAD_ACTIONS.NONE,
            leadTimes,
            successMessage: 'Operação realizada com sucesso',
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            loading: LEAD_ACTIONS.NONE,
            errorMessage: errorHandler(error),
          }))
        }
      },
      resetMessages() {
        setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
      },
    }
  }, [])

  return { state, localDispatch }
}
